// The same note rule as the server (src/shared/pipeline/lost-reason.js):
// closing business as Lost needs a list reason AND a real note on what
// happened (client, 2026-10-29) — "close" is not a reason.

export const LOST_NOTE_MIN = 10;

const EMPTY_WORDS = /^(?:cl[a-z]?o?s?r?e?d?|closed?|closre|lost|na|nil|no|ok|done|test|x+|\.+)+$/;

/** Why this note is not good enough, or null when it is. */
export function lostNoteProblem(note: string | null | undefined): string | null {
  const text = String(note || '').trim();
  if (!text) return `Write what happened — at least ${LOST_NOTE_MIN} characters (e.g. "bought from another supplier at a lower rate").`;
  const letters = text.toLowerCase().replace(/[^a-z]/g, '');
  if (EMPTY_WORDS.test(letters)) return 'Write what actually happened — "close" is not a reason.';
  if (text.length < LOST_NOTE_MIN) return `Write a little more on what happened — at least ${LOST_NOTE_MIN} characters.`;
  return null;
}
